import { createSelector } from 'reselect';

import { SEARCH_KEY_TEXT_MAP } from '../const';
import searchSelector from './search';

const DEFAULT = [];

/**
 * make a suggestions selector
 * @returns {Function} a suggestions selector
 */
const makeSuggestions = function makeSuggestionsSelector() {
  return createSelector(searchSelector, search => {
    const { suggestions = DEFAULT } = search;
    const retval = [];
    suggestions.forEach(suggestion => {
      const { type: key } = suggestion;
      const text = SEARCH_KEY_TEXT_MAP[key] || key;
      const transformed = suggestion.data.map(val => ({
        text,
        key,
        val
      }));
      retval.push(...transformed);
    });
    return retval;
  });
};

export default makeSuggestions;
